






















































































































































































































































































import { Prop, Component, Vue } from 'vue-property-decorator'
import OzBaseButton from 'library/v4/components/OzBaseButton.vue'

export enum OzContainedButtonColorScheme {
  Bare = 'Bare',
  Primary = 'Primary',
  PrimaryPulsing = 'PrimaryPulsing',
  Secondary = 'Secondary',
  SecondaryClear = 'SecondaryClear',
  Alternative = 'Alternative',
  AlternativeHeavy = 'AlternativeHeavy',
  Green = 'Green',
  Orange = 'Orange',
  Destructive = 'Destructive',
  Active = 'Active',
}

export enum OzContainedButtonSizePreset {
  Bare = 'Bare',
  H40px = 'H40px',
  H32px = 'H32px',
  H24px = 'H24px',
}

/**
 * It's named "contained button" following Material UI's terminology: https://material.io/components/buttons .
 *
 *
 * This component applies three types of styles:
 *
 * 1. Shape/size
 * 2. Colors
 * 3. Text truncation
 *
 *
 * To make customization easy, it's built so that you can (re)use each group of styles independently,
 * i.e. each type of style is optional. Notice that if you set `:color-scheme="null"`, `:size-preset="null"`
 * and use the default slot, it reduces to `OzBaseButton`.
 *
 */
@Component({ components: { OzBaseButton } })
export default class OzContainedButton extends Vue {
  ColorScheme = OzContainedButtonColorScheme
  SizePreset = OzContainedButtonSizePreset

  /**
   * Dark mode.
   */
  @Prop({ default: 'auto' }) darkMode!: true | false | 'auto'

  /**
   * Automatically uses an `<a>` tag if href is present, `<button>` otherwise.
   */
  @Prop({ default: undefined }) href?: string

  /**
   * Color scheme.
   */
  @Prop({ default: OzContainedButtonColorScheme.Primary }) colorScheme!: OzContainedButtonColorScheme

  /**
   * Applies preset sizes/shapes.
   * They are named with pixel values for developer ergonomics -- those are the values you see in the mockups.
   * Technically, the pixel value could vary depending on the size of `rem`.
   */
  @Prop({ default: OzContainedButtonSizePreset.H40px }) sizePreset!: OzContainedButtonSizePreset

  /**
   * Text. Automatically handles truncation and adds title.
   */
  @Prop({ default: undefined }) text?: string

  /**
   * Adds extra padding to center the text if there's an icon.
   */
  @Prop({ default: false }) centerText?: boolean

  /**
   * Tailwind uses box shadows for focus rings.
   * Didn't find a straightforward way to implement truly transparent offset color.
   * If the gap color is too different from the backdrop, customize it here.
   */
  @Prop({ default: undefined }) ringOffsetColorClasses?: Record<string, boolean>

  handleClick(event): void {
    /**
     * Click event.
     * @property {MouseEvent} event click event
     */
    this.$emit('click', event)
  }
}
